<template>
    <div>
        <div v-if="projects.length > 0" class="grid grid-cols-1 col-gap-6 row-gap-8">
            <template v-for="(project, index) in projects">
                <project-card v-if="index < limit" :key="index" :project="project" />
            </template>
        </div>
        <div v-else class="text-gray-600 font-normal text-center font-hairline">
            No posted job for now, we'll keep you posted.
        </div>
        <div v-if="projects.length > limit" class="flex justify-around mt-12">
            <a href="/projects" class="btn btn-line-primary rounded">See More</a>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        limit: {
            type: [String, Number],
            default: 10
        }
    },

    data() {
        return {
            projects: []
        };
    },

    mounted() {
        this.fetchProjects();
    },

    methods: {
        fetchProjects() {
            axios.get(`/api/projects?limit=${this.limit + 1}`).then(response => {
                this.projects = response.data.data;
            });
        }
    }
};
</script>
